import { Environment } from 'src/const/constants';

export const PathRoutes = {
  // Default route which manages redirection based on
  // authentication level of the user in the router
  RootRoute: '/',

  // Side navigation routes
  LoginRoute: '/login',
  FeedPageRoute: '/feed',
  ProfileRoute: '/profile',

  // Feature routes
  // TODO clean up feature specific routing
  CreateProfileRoute: '/create-profile',
  EditProfileRoute: '/edit-profile',
  UserCircle: '/circle/:id',
  AuctionRoute: '/auction/:id',
  ChallengePageRoute: '/circle/:id/challenge/:id',
  CreateCircleRoute: '/create-circle',
  EditCircleRoute: '/edit-circle/:id',
  OthDevelopmentPlanRoute: '/oth/utviklingsplan',

  // Admin and WIP routes
  AdminPageRoute: '/admin',
  Admin360PageRoute: '/admin/360',
  // OTH 360 invite flow (public, no main layout)
  Oth360InviteRoute: '/oth/360',
  Oth360AuthRoute: '/oth/360/auth',
  Oth360FormRoute: '/oth/360/form',
  Oth360ResultsRoute: '/oth/360/results',
  OthRegistrationRoute: '/oth/registration/:tribeId',
  ...(process.env.REACT_APP_API_ENV !== Environment.PROD && {
    AIAssistantRoute: '/ai-assistant',
  }),
};
